// import type { SortType } from '@shared/ui/sort-item';
export type OrderType = 'asc' | 'desc';

export interface SortType {
  column: string;
  order: OrderType;
}

export const artworksSortOptions: {
  text: string;
  value: SortType;
}[] = [
  {
    text: 'Newest',
    value: {
      column: 'year',
      order: 'desc',
    },
  },
  {
    text: 'Oldest',
    value: {
      column: 'year',
      order: 'asc',
    },
  },
  {
    text: 'Artist A-z',
    value: {
      column: 'artist',
      order: 'asc',
    },
  },
  {
    text: 'Artist z-A',
    value: {
      column: 'artist',
      order: 'desc',
    },
  },
];
